<template>
  <div class="tw:flex tw:items-center tw:gap-3" :class="{ 'tw:opacity-50': disabled }">
    <input
      v-bind="$attrs"
      :id="id"
      type="radio"
      :model-value="modelValue"
      :checked="modelValue === value"
      :name="name"
      :data-testid="id"
      :disabled="disabled"
      :class="{ 'skeleton-play': skeleton }"
      @change="update"
    />

    <TextPlay
      v-if="label"
      :skeleton="skeleton"
      size="sm"
      weight="semibold"
      tag="label"
      color="var(--fontcolor)"
      :for="id"
      :text="label"
    />
  </div>
</template>

<script lang="ts" setup>
import TextPlay from '../TextPlay/TextPlay.vue'

const props = defineProps<{
  label?: string
  value?: string | number | null
  modelValue?: string | number | null
  id?: string
  name: string
  disabled?: boolean
  skeleton?: boolean
}>()

const emit = defineEmits(["update:modelValue"])

function update() {
  emit("update:modelValue", props.value)
}
</script>

<style scoped>
input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  width: 1rem;
  height: 1rem;
  border: 1.5px solid color-mix(in srgb, var(--fontcolor) 40%, transparent);
  border-radius: 50%;
  cursor: pointer;
  background-color: transparent;
  transition: background-color 0.15s, border-color 0.15s;
  flex-shrink: 0;
}

input[type="radio"]:checked {
  background-color: var(--maincolor);
  border-color: var(--maincolor);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Ccircle cx='8' cy='8' r='3' fill='white'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
}

input[type="radio"]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
